/**
 * A surface that covers the center (Team settings) folds the rail to its
 * strip while it is open, the way a wide sheet does, so the overlay keeps the
 * room. Counted, so two holders never unfold each other.
 */
import { useEffect, useSyncExternalStore } from "react";

let holders = 0;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const folded = () => holders > 0;

/** Fold the rail while `active` is true. */
export function useFoldRail(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    holders += 1;
    emit();
    return () => {
      holders -= 1;
      emit();
    };
  }, [active]);
}

/** Whether anything holds the rail folded. */
export function useRailFolded(): boolean {
  return useSyncExternalStore(subscribe, folded, folded);
}
